import Blank from "@/layouts/blank.vue"

import CustomerContractV2List from "@/pages/admin/customer-contract-v2/CustomerContractV2List.vue";
import CustomerContractV2Add from "@/pages/admin/customer-contract-v2/CustomerContractV2Add.vue";
import CustomerContractV2Edit from "@/pages/admin/customer-contract-v2/CustomerContractV2Edit.vue";

const customerContractV2Routes = [
  {
    path: "customer-contract-v2",
    name: "app-admin-customer-contract-v2",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/customer-contract-v2/list",
      },
      {
        path: "list",
        name: "app-admin-customer-contract-v2-list",
        component: CustomerContractV2List,
      },
      {
        path: "add",
        name: "app-admin-customer-contract-v2-add",
        component: CustomerContractV2Add,
      },
      {
        path: "edit",
        name: "app-admin-customer-contract-v2-edit",
        component: Blank,
        children: [
          {
            path: "/",
            redirect: "/app/admin/customer-contract-v2/list",
          },
          {
            path: ":id",
            name: "app-admin-customer-contract-v2-edit-id",
            component: CustomerContractV2Edit,
          }
        ]
      },
    ]
  },
]

export default customerContractV2Routes
